module.exports = {
    sqft: '*',
    numOfBeds: '*',
    numOfBaths: '*',
    den: false,
    walkInCloset: false,
    tub: false,
    accessibility: false,
    balcony: false,
    terrace: false,
    storageRoom: false,
};